import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Intro from "../intro/Intro";
import About from "../about/About";
import Skills from "../skills/Skills";
import Works from "../works/Works";
import Contact from "../contact/Contact";

/**
 * Home Component
 *
 * Contains homepage sections: Intro, About, Skills, Works, Contact
 */
export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
    }
  }, [location.hash]);

  return (
    <div className="sections">
      <Intro></Intro>
      <About></About>
      <Skills></Skills>
      <Works></Works>
      <Contact></Contact>
    </div>
  );
}
